import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { QUICK_CREATE, canAccess } from "@/lib/navRegistry";

// Global + Create. Task/Reminder are live (My Tasks); others arrive with their module.
export function QuickCreate({ ctx }) {
  const navigate = useNavigate();
  const items = QUICK_CREATE.filter((i) => canAccess(i, ctx));
  const onClick = (i) => {
    if (i.id === "task") navigate("/tasks?new=task");
    else if (i.id === "reminder") navigate("/tasks?new=reminder");
    else toast("Coming soon", { description: `${i.label} creation arrives with its module.` });
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" className="gap-1.5" data-testid="quick-create"><Plus className="h-4 w-4" /> <span className="hidden sm:inline">Create</span></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wide text-muted-foreground">Create new</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.map((i) => (
          <DropdownMenuItem key={i.id} data-testid={`create-${i.id}`} onClick={() => onClick(i)}>
            {i.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
